import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PaymentRowService {
  constructor(private http: HttpClientService) {}

  public getPaymentRowDetails(id) {
    return this.http
      .get("/api/payment_rows/" + id + "/details")
      .pipe(tap((_) => console.log("PaymentRowService.getPaymentRowDetails: Ok.")));
  }
}
